import { render, staticRenderFns } from "./PatientConfirmation.vue?vue&type=template&id=3756d672&"
import script from "./PatientConfirmation.vue?vue&type=script&lang=js&"
export * from "./PatientConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports